import { useEffect, useState } from 'react';
import { StyledTable } from '../../components';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import moment from 'moment';
import TableActionsBar from '../../components/TableActionBar/TableActionBar';
import WcpaHistoryTable from '../../components/WcpaHistoryTable/WcpaHistoryTable';
import { fetchProcessedData } from '../../redux/actionCreators/station';
import { isPuneJlr } from '../../constants';
import { Box } from '@mui/material';

const DEFAULT_COLUMNS = [
  {
    width: 160,
    title: 'STATION ID',
    field: 'dtStationId',
    sortable: true,
    render: (row) => (
      <Typography
        sx={{
          opacity: 0.8,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          textAlign: 'center',
        }}
      >
        {row?.dtStationId ?? '—'}
      </Typography>
    ),
  },
  {
    width: 300,
    title: 'LAST PROCESSED VIN',
    field: 'lastProcessedVin',
    sortable: true,
    enableSearch: true,
    enableFilter: true,
    align: 'left',
    render: (row) => (
      <Typography
        sx={{
          opacity: 0.8,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          textAlign: 'left',
          fontWeight: 600,
          letterSpacing: '0.3px',
        }}
      >
        {row?.lastProcessedVin ?? '—'}
      </Typography>
    ),
  },
  {
    width: 200,
    title: 'KSPEC NUMBER',
    field: 'kspec',
    sortable: true,
    render: (row) => (
      <Typography
        sx={{
          opacity: 0.8,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          textAlign: 'center',
        }}
      >
        {row?.kspec ?? '—'}
      </Typography>
    ),
  },
  {
    width: 280,
    title: 'KSPEC DESCRIPTION',
    field: 'kspecDescription',
    sortable: true,
    align: 'left',
    render: (row) => (
      <Typography
        sx={{
          opacity: 0.8,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          textAlign: 'left',
        }}
      >
        {row?.kspecDescription ?? '—'}
      </Typography>
    ),
  },
  {
    width: 220,
    title: 'LAST PROCESSED AT',
    field: 'lastProcessedAt',
    sortable: true,
    render: (row) => (
      <Typography
        sx={{
          opacity: 0.8,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          textAlign: 'center',
        }}
      >
        {row?.lastProcessedAt
          ? moment(row.lastProcessedAt).format('DD-MM-YYYY HH:mm:ss')
          : '—'}
      </Typography>
    ),
  },
];

const NewProcessedPage = ({stationName = ""}) => {
  const dispatch = useDispatch();
  const [processedData, setProcessedData] = useState([]);
  const [wcpaHistory, setWcpaHistory] = useState({
    SFLT_AND_WCPA_COMPLETED:  [],
    WCPA_COMPLETED: [],
  });
  const [columns, setColumns] = useState(DEFAULT_COLUMNS);
  const [filters, setFilters] = useState({});

  const getData = (stationName) => {
		if (stationName === 'WCPA' && isPuneJlr()) {
			dispatch(
				fetchProcessedData(
					stationName,

					(response) => {
						setWcpaHistory({
							SFLT_AND_WCPA_COMPLETED: response?.SFLT_PART ?? [],
							WCPA_COMPLETED: response?.LIVE_PART ?? [],
						});
					},

					(error) => {
						console.error(error);

						setWcpaHistory({
							SFLT_AND_WCPA_COMPLETED: [],
							WCPA_COMPLETED: [],
						});
					},
				),
			);
		} else {
			dispatch(
				fetchProcessedData(
					stationName,
					(response) => {
						const data = response?.data || response;
						const rawArray = Array.isArray(data) ? data : data ? [data] : [];
						const mapped = rawArray.map((item, index) => ({
							...item,
							id: item.dtStationId ?? index,
							lastProcessedVin: item.vin ?? item.lastProcessedVin,
							lastProcessedAt: item.processedAt ?? item.lastProcessedAt,
						}));
						setProcessedData(mapped);
					},
					(error) => {
						console.error('Failed to fetch processed data:', error);
						setProcessedData([]);
					},
				),
			);
		}
	};

  useEffect(() => {
    getData(stationName);
  }, [stationName]);

  return (
		<>
			{stationName === 'WCPA' && isPuneJlr() ? (
				<Box
					sx={{
						display: 'grid',
						gridTemplateColumns: '1fr 1fr',
						gap: 2,
						height: '90%',
						p: 2,
            
					}}
				>
					<WcpaHistoryTable title="SFLT COMPLETED" rows={wcpaHistory.SFLT_AND_WCPA_COMPLETED} />
					<WcpaHistoryTable title="WCPA COMPLETED" rows={wcpaHistory.WCPA_COMPLETED} />
				</Box>
			) : (
				<>
					<TableActionsBar
						showColumns
						showFilter
						columns={columns}
						defaultColumns={DEFAULT_COLUMNS}
						onColumnChange={setColumns}
						rows={processedData}
						onFilterChange={(filters) => setFilters(filters)}
					/>

					<StyledTable
						columns={columns}
						rows={processedData}
						filters={filters}
						sx={{ flex: 1 }}
						elevated
            isRowClickCopy={true}
					/>
				</>
			)}
		</>
	);
};

export default NewProcessedPage;